import { ApiCollection }    from './ApiCollection';
import { ConnectorResults } from '@mathquis/modelx';
import { Model }            from '@mathquis/modelx';

export class PagedCollection<T extends Model = Model> extends ApiCollection<T> {
  public filters: any = {};

  public itemsPerPage = 5;
  public page = 1;
  public total = 0;

  public onListSuccess(connectorResults: ConnectorResults, options: object) {
    this.total = connectorResults.res.data['hydra:totalItems'];
    super.onListSuccess(connectorResults, options);
  }

  public prepareListOptions(options: any) {
    return super.prepareListOptions({
      ...options,
      filters: {
        itemsPerPage: this.itemsPerPage,
        page: this.page,
        ...(options?.filters || {}),
      },
    });
  }

  public setPage(page: number = 1) {
    this.page = page;
  }
}
